import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=5363768c&"
import script from "./Cart.vue?vue&type=script&lang=ts&"
export * from "./Cart.vue?vue&type=script&lang=ts&"
import style0 from "./Cart.vue?vue&type=style&index=0&id=5363768c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports